import { render, staticRenderFns } from "./form-settings.vue?vue&type=template&id=f24bcdf6&scoped=true&"
import script from "./form-settings.vue?vue&type=script&lang=js&"
export * from "./form-settings.vue?vue&type=script&lang=js&"
import style0 from "./form-settings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./form-settings.vue?vue&type=style&index=1&id=f24bcdf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24bcdf6",
  null
  
)

export default component.exports